<template>
  <div>
    <div class="contenido" id="content-redeem">
      <div
        class="row ptp justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-middle"
      >
        <div class="col col-10 col-md-6 col-lg-4 col-xl-3 col-sm-12">
          <h5 class="text-title pt-3"><strong>INGRESA TU CÓDIGO</strong></h5>
          <div class="input-group mb-3">
            <input
              v-model="code"
              type="text"
              class="form-control input-code"
              aria-label="Email"
              placeholder="INGRESA TU NUEVO CÓDIGO ACÁ"
              aria-describedby="basic-addon1"
            />
          </div>
          <button
            :disabled="disableLoading"
            @click="redeemCode()"
            type="button"
            class="btn btn-danger btn-md btn-block button-send"
          >
            <span
              v-if="disableLoading"
              class="spinner-border spinner-border-lg"
              role="status"
              aria-hidden="true"
            ></span>
            <strong v-else>ENVIAR</strong>
          </button>
          <small class="text-small text-left"
            >Entre más códigos ingreses, más oportunidades tienes de
            ganar.</small
          >
        </div>
        <div class="col col-10 col-md-5 col-lg-2 col-xl-3 col-sm-12">
          <img
            src="../../assets/logo-login.png"
            class=" img-fluid img-redeem-code"
            alt="..."
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      disableLoading: false
    };
  },
  methods: {
    redeemCode() {
      this.disableLoading = true;
      var app = this;
      var data = {
        code: this.code
      };
      axios
        .post("superAdmin/redeemCode", data)
        .then(function(res) {
          if (res.data.ResponseCode == 1 || res.data.ResponseCode == 2) {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.ResponseMessage
            });
            app.disableLoading = false;
          }

          if (res.data.ResponseCode == 0) {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.ResponseMessage
            });
            app.disableLoading = false;
          }
          app.code = "";
        })
        .catch(function(error) {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text:
              "Hubo un error, intente en un momento o contáctese con el administrador"
          });
          app.disableLoading = false;
        });
    }
  }
};
</script>

<style scope>
.contenido {
  height: 888px;
}
#content-redeem {
  background-size: cover;
  background-image: url("../../assets/contenido3.png");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";

}
.ptp {
  padding-top: 10rem !important;
}
.text-title {
  font-family: "ubuntu-bold", sans-serif !important;
  color: white !important;
  text-align: left !important;
  font-size: 16px !important;
  padding-bottom: 14px !important;
  font-display: swap;

}
.input-code {
  background-color: #ffffff00 !important;
  font-family: "ubuntu-regular", sans-serif !important;
  border-radius: 10px !important;
  border-color: white !important;
  height: 60px !important;
  color: white !important;
  padding: 0.375rem 1.7rem !important;
  font-size: 20px !important;
  font-display: swap;
}
.input-code::placeholder {
  font-family: "ubuntu-regular", sans-serif;
  font-size: 17px;
  color: white !important;
  font-display: swap;
}
.button-send {
  border-radius: 10px !important;
  height: 50px !important;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.text-small {
  float: left;
  color: white;
}
.img-redeem-code {
  float: right;
}

/* TABLET */
@media (max-width: 1023px) {
  .input-code {
    font-size: 20px !important;
  }
  .input-code::placeholder {
    font-size: 16px;
    color: white !important;
  }
  .text-small {
    float: left;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .contenido {
    height: 750px;
  }
  .title-profile {
    text-align: center !important;
  }
  .img-redeem-code {
    text-align: center !important;
    padding-top: 20px !important;
    content: url("./../../assets/logo-login.png");
  }
  .ptp {
    padding-top: 8rem !important;
  }
  .col-m {
    margin-top: 10% !important;
    margin-bottom: 10% !important;
  }
  .input-code {
    font-size: 13px !important;
    text-align: center !important;
    height: 50px !important;
  }
  .input-code::placeholder {
    font-size: 13px !important;
    text-align: center !important;
  }
  .text-small {
    float: left;
  }
  #content-redeem {
    background-size: cover;
    background-image: url("../../assets/contenido3-mobile.png");
    background-position: center center;
    background-attachment: fixed;
    background-color: "#171717";
  }
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "ubuntu-light";
  src: url("./../../assets/font/Ubuntu-Light.ttf");
  font-display: swap;
}
@font-face {
  font-family: "ubuntu-regular";
  src: url("./../../assets/font/Ubuntu-Regular.ttf");
  font-display: swap;
}
</style>
